import Empty from '../empty/Empty'
import './video.css'

const Video = ({data, isVideo}) => {

      if(!isVideo) return 

      return (
            <div className={isVideo ? "pager_content show" : "pager_content"}>
                  <div className="header_page">
                        <span className="bg_grad">Video</span>
                  </div>
                  <div className="section_page video">
                        {
                              (!data.data)
                                    ?
                                         <>
                                         <div className="video_title">
                                                <span>{data[0].title}</span>
                                          </div>
                                          <div className="video_box">
                                                <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${data[0].id_video}`} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ></iframe>
                                          </div>
                                          </>
                                    : <Empty text={"Oops! Not Video Added"}/>
                        }
                        
                  </div>
            </div>
      )
}

export default Video
